var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col" }, [
    _c("div", { staticClass: "card card-stats" }, [
      _c(
        "div",
        {
          staticClass: "card-body",
          class: { "btn text-left": _vm.onClickHandler },
          on: { click: _vm.onCardClick }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "h5",
                {
                  staticClass:
                    "card-title text-uppercase text-muted mb-0 text-custom-dashboard"
                },
                [_vm._v(_vm._s(_vm.title))]
              ),
              _c("span", { staticClass: "h2 font-weight-bold mb-0" }, [
                _vm._v(_vm._s(_vm.value !== undefined ? _vm.value : "N/A"))
              ])
            ]),
            _c("div", { staticClass: "col-auto" }, [
              _c(
                "div",
                {
                  staticClass:
                    "icon icon-shape text-white rounded-circle shadow",
                  class: [_vm.color]
                },
                [_c("i", { class: [_vm.icon] })]
              )
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }